import { render, staticRenderFns } from "./CommentManagement.vue?vue&type=template&id=7fb01822&scoped=true"
import script from "./CommentManagement.vue?vue&type=script&lang=js"
export * from "./CommentManagement.vue?vue&type=script&lang=js"
import style0 from "./CommentManagement.vue?vue&type=style&index=0&id=7fb01822&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb01822",
  null
  
)

export default component.exports